/** Exact primitives shared by governed JSON document parsers. */
export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

export const recordOrNull = (value: unknown): Record<string, unknown> | null =>
  isRecord(value) ? value : null

export const exactKeys = (value: Record<string, unknown>, keys: readonly string[]): boolean =>
  Object.keys(value).sort().join('|') === [...keys].sort().join('|')

export const integerInRange = (value: unknown, min: number, max: number): boolean =>
  typeof value === 'number' && Number.isInteger(value) && value >= min && value <= max

export const unknownKeys = (value: Record<string, unknown>, allowed: ReadonlySet<string>, at: string): string[] =>
  Object.keys(value).filter((key) => !allowed.has(key)).map((key) => `${at}.${key} is not part of the finite grammar`)
